import { motion } from 'framer-motion';

interface GameSummaryProps {
  duration: number; // in seconds
  playersCount: number;
  numbersCalled: number;
}

export function GameSummary({ duration, playersCount, numbersCalled }: GameSummaryProps) {
  // Format seconds to mm:ss
  const formatTime = (secs: number) => {
    const mins = Math.floor(secs / 60);
    const remainingSecs = secs % 60;
    return `${mins.toString().padStart(2, '0')}:${remainingSecs.toString().padStart(2, '0')}`;
  };

  const statItems = [
    { label: 'Match Duration', value: formatTime(duration), icon: '⏱️' },
    { label: 'Total Players', value: playersCount.toString(), icon: '👥' },
    { label: 'Numbers Called', value: `${numbersCalled} / 90`, icon: '🎱' },
  ];

  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col justify-between h-full text-left select-none">
      <div className="space-y-4">
        <h3 className="font-display text-sm font-black tracking-wider text-amber-300 uppercase">
          Match Statistics
        </h3>

        <div className="space-y-3">
          {statItems.map((item, idx) => (
            <motion.div
              key={item.label}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: idx * 0.1, duration: 0.5 }}
              className="glass-light p-3.5 rounded-xl border border-white/5 flex items-center justify-between hover:border-purple-500/10 transition-colors"
            >
              <div className="flex items-center space-x-3 text-left">
                <span className="text-sm">{item.icon}</span>
                <span className="text-[9px] uppercase tracking-wider text-surface-400 font-bold">
                  {item.label}
                </span>
              </div>
              <span className="text-xs font-black font-mono text-white">
                {item.value}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default GameSummary;
